import { render, staticRenderFns } from "./CameraCapture.vue?vue&type=template&id=89ace096&scoped=true"
import script from "./CameraCapture.vue?vue&type=script&lang=js"
export * from "./CameraCapture.vue?vue&type=script&lang=js"
import style0 from "./CameraCapture.vue?vue&type=style&index=0&id=89ace096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ace096",
  null
  
)

export default component.exports